import { render, staticRenderFns } from "./journalismDetails.vue?vue&type=template&id=60e6bb49&scoped=true"
import script from "./journalismDetails.vue?vue&type=script&lang=js"
export * from "./journalismDetails.vue?vue&type=script&lang=js"
import style0 from "./journalismDetails.vue?vue&type=style&index=0&id=60e6bb49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6bb49",
  null
  
)

export default component.exports